module.exports = __webpack_public_path__ + "9ac8933b48b5b325e3df4343bd57502f.pdf";